import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, SignInButton, UserButton } from "@clerk/clerk-react";
import TokenSummary from './screens/TokenSummary';
import CallerStatsScreen from './screens/CallerStatsScreen';
import TokenPositionPage from "./screens/TokenPositionPage";



const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#F9FAFB', // bg-gray-50
  },
  nav: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', // shadow-sm
  },
  navInner: {
    maxWidth: '80rem', // max-w-7xl
    margin: '0 auto',
    padding: '0 1rem', // px-4
  },
  navContent: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '4rem', // h-16
    alignItems: 'center',
  },
  linkContainer: {
    display: 'flex',
    gap: '2rem', // space-x-8
  },
  link: {
    color: '#374151', // text-gray-700
    padding: '0.5rem 0.75rem', // px-3 py-2
    borderRadius: '0.375rem', // rounded-md
    fontSize: '0.875rem', // text-sm
    fontWeight: '500', // font-medium
  },
  signInButton: {
    backgroundColor: '#3B82F6', // bg-blue-500
    color: '#FFFFFF',
    padding: '0.5rem 1rem', // px-4 py-2
    borderRadius: '0.375rem', // rounded-md
    fontSize: '0.875rem', // text-sm
    fontWeight: '500', // font-medium
    cursor: 'pointer',
    border: 'none',
    ':hover': {
      backgroundColor: '#2563EB', // hover:bg-blue-600
    },
  },
  main: {
    maxWidth: '80rem', // max-w-7xl
    margin: '0 auto',
    padding: '1.5rem 1rem', // py-6 sm:px-6
  },
  authButtonsContainer: {
    display: 'flex',
    alignItems: 'center',
  }
};

// Create hover effects using event handlers
const linkHoverStyle = {
  color: '#111827', // hover:text-gray-900
};

const ProtectedRoute = ({ children }) => {
  return (
    <SignedIn>
      {children}
    </SignedIn>
  );
};

const Navigation = () => {
  const [hoveredLink, setHoveredLink] = React.useState(null);
  const [hoveredButton, setHoveredButton] = React.useState(false);

  return (
    <nav style={styles.nav}>
      <div style={styles.navInner}>
        <div style={styles.navContent}>
          <div style={styles.linkContainer}>
            <a
              href="/"
              style={{
                ...styles.link,
                ...(hoveredLink === 'tokens' ? linkHoverStyle : {})
              }}
              onMouseEnter={() => setHoveredLink('tokens')}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Monitored Tokens
            </a>
            <a
              href="/caller-stats"
              style={{
                ...styles.link,
                ...(hoveredLink === 'stats' ? linkHoverStyle : {})
              }}
              onMouseEnter={() => setHoveredLink('stats')}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Caller Stats
            </a>
          </div>
          <div style={styles.authButtonsContainer}>
            <button
              style={{
                ...styles.signInButton,
                backgroundColor: hoveredButton ? '#2563EB' : '#3B82F6',
              }}
              onMouseEnter={() => setHoveredButton(true)}
              onMouseLeave={() => setHoveredButton(false)}
            >
              <SignedOut>
                <SignInButton style={styles.signInButton} mode="modal" />
              </SignedOut>
              <SignedIn>
                <UserButton afterSignOutUrl="/" />
              </SignedIn>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

const App = () => {
  return (
    <div style={styles.container}>
      <main style={styles.main}>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Navigation />

            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <TokenSummary />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/caller-stats"
                  element={
                    <ProtectedRoute>
                      <CallerStatsScreen />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/sign-in/*"
                  element={
                    <SignedOut>
                      <SignInButton mode="modal" />
                    </SignedOut>
                  }
                />
                <Route
                  path="/position"
                  element={<TokenPositionPage />}
                />
                <Route
                  path="*"
                  element={<Navigate to="/" replace />}
                />
              </Routes>
            </main>
          </div>
        </Router>
      </main>
    </div>
  );
};


export default App;